module.exports = __webpack_public_path__ + "static/bounty-ee740afb6a9b8f52eb0e39d86584e2a1.jpeg";